export default __webpack_public_path__ + "static/media/pumpkindb.2afbbee2.svg";